import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <SectionWrapper bgColor="warmWhite" data-id="element-120">
      <div className="bg-white rounded-3xl p-6 md:p-8 border-2 border-primary/20 shadow-lg relative overflow-hidden" data-id="element-121">
        <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-bl-full -z-10" data-id="element-122"></div>

        <div className="flex flex-col items-center text-center" data-id="element-123">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4" data-id="element-124">
            <ShieldCheck className="w-8 h-8 text-primary" data-id="element-125" />
          </div>

          <h2 className="font-serif text-3xl font-bold text-dark mb-4" data-id="element-126">
            Tu Inversión Está 100% Protegida
          </h2>

          <div className="inline-block bg-primary text-white font-bold px-6 py-2 rounded-full mb-5 text-sm tracking-wider" data-id="element-127">
            GARANTÍA DE 14 DÍAS
          </div>

          <div className="font-sans text-gray-700 space-y-4 text-lg max-w-lg" data-id="element-128">
            <p data-id="element-129">
              Prueba el Protocolo Hígado Vital por 14 días completos. Si sigues
              las dos fases y no notas ninguna diferencia en tu energía, en tu
              abdomen o en cómo te sientes al despertar, te devolvemos cada
              centavo.
            </p>
            <p data-id="element-130">
              Sin preguntas. Sin formularios complicados. Sin riesgos para ti.
            </p>
            <p className="font-bold text-dark text-xl mt-6" data-id="element-131">
              La única forma en que pierdes es si no lo intentas.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}